export async function logout(isSaasInternalRoute: boolean): Promise<void> {
  try {
    await fetch(isSaasInternalRoute ? '/saas/auth/logout' : '/auth/oidc/logout', {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    // Best-effort logout still redirects to the correct login surface.
  }
  window.location.href = isSaasInternalRoute ? '/saas-login' : '/login';
}
